var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelationClient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(-200 -7598)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(200 7598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "high-five",
    transform: "translate(219.959 7591.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(40.692 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M247.641,20a1.654,1.654,0,0,0-1.654,1.654V31.5a1.654,1.654,0,0,0,3.308,0V21.654A1.654,1.654,0,0,0,247.641,20Z",
    transform: "translate(-245.987 -20)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(26.191 29.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M165.111,82.988l-3.958-3.954a1.654,1.654,0,1,0-2.339,2.34l3.958,3.954a1.654,1.654,0,0,0,2.338-2.34Z",
    transform: "translate(-158.33 -78.55)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122",
    transform: "translate(50.988 29.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M315.264,79.057a1.654,1.654,0,0,0-2.34,0l-4.208,4.211a1.654,1.654,0,0,0,2.341,2.339l4.208-4.211A1.654,1.654,0,0,0,315.264,79.057Z",
    transform: "translate(-308.233 -78.573)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(0 44.855)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M73.861,189.069H72.526a8.383,8.383,0,0,0,1.739-5.119v-2.335a8.427,8.427,0,1,0-16.854,0v1.815L44.966,170.985a2.494,2.494,0,0,0-2.618-.583,2.494,2.494,0,0,0-2.618.583L27.285,183.43v-1.815a8.427,8.427,0,0,0-16.854,0v2.335a8.382,8.382,0,0,0,1.739,5.119H10.835A10.848,10.848,0,0,0,0,199.9v21.918a1.654,1.654,0,0,0,1.654,1.654H8.643a1.653,1.653,0,0,0,.476-.07,1.653,1.653,0,0,0,.476.07H28.122a1.654,1.654,0,0,0,1.654-1.654V216.2a1.654,1.654,0,0,0-3.308,0v3.97H11.249V201.319a1.654,1.654,0,1,0-3.308,0v18.849H3.308V199.9a7.535,7.535,0,0,1,7.527-7.527h11.5A1.649,1.649,0,0,0,23.5,191.9l0,0L40.684,174.71a18.215,18.215,0,0,1-3.108,9.606L26.75,200.395a1.655,1.655,0,0,0-.282.924v1.811a1.654,1.654,0,1,0,3.308,0v-1.306l10.544-15.66a21.652,21.652,0,0,0,2.028-3.773,21.641,21.641,0,0,0,2.028,3.773l10.544,15.66v20a1.654,1.654,0,0,0,1.654,1.654H75.1a1.653,1.653,0,0,0,.476-.07,1.654,1.654,0,0,0,.476.07h6.989a1.654,1.654,0,0,0,1.654-1.654V199.9A10.847,10.847,0,0,0,73.861,189.069ZM23.977,183.95a5.119,5.119,0,1,1-10.237,0v-2.335a5.119,5.119,0,1,1,10.237,0Zm36.742-2.335a5.119,5.119,0,0,1,10.237,0v2.335a5.119,5.119,0,1,1-10.237,0Zm20.668,38.553H76.756V207.927a1.654,1.654,0,1,0-3.308,0v12.241H58.228V201.319a1.654,1.654,0,0,0-.282-.924L47.12,184.316a18.215,18.215,0,0,1-3.108-9.606l17.182,17.182c.022.022.042.04.062.057a1.646,1.646,0,0,0,1.107.428h11.5a7.535,7.535,0,0,1,7.527,7.527v20.264Z",
    transform: "translate(0 -170.252)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(73.447 74.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M446.824,348.535a1.653,1.653,0,1,0,.485,1.17A1.666,1.666,0,0,0,446.824,348.535Z",
    transform: "translate(-444 -348.05)",
    fill: "#ed8e88"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128",
    transform: "translate(26.467 83.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M162.824,401.485a1.653,1.653,0,1,0,.485,1.17A1.666,1.666,0,0,0,162.824,401.485Z",
    transform: "translate(-160 -401)",
    fill: "#ed8e88"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelationClient);
export default __webpack_public_path__ + "static/media/relationClient.34c009edfaf441f57afe00d1adc6e89e.svg";
export { ForwardRef as ReactComponent };